import { jsx as _jsx } from "react/jsx-runtime";
// Must run in this chunk before RTK/Immer — entry (index.tsx) imports a different bundle copy of immer.
import '../../immer-init';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'broadcastchannel-polyfill';
import '../../styles';
import '../cmx/cmx.scss';
import './index.css';
import Main from './Main';
import * as serviceWorker from '../../serviceWorker';
import '../../core/view-utils/iframe-adjust';
import { registerVisibilityListener } from '../page-visibility';
import Template from './template';
registerVisibilityListener(document);
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element not found');
}
const root = createRoot(container);
if (!process.env.TEMPLATE_ENV) {
    root.render(/*#__PURE__*/ _jsx(Main, {}));
} else {
    root.render(/*#__PURE__*/ _jsx(Template, {}));
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
